import { useContext } from "react";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import { useUserOrganizations } from "@/application/queries";
import { AuthContext } from "@/contexts/AuthContext";
import type { CurrentOrganizationContext } from "@/domain/organization";

export const useCurrentOrganization = (): CurrentOrganizationContext | null => {
	const authContext = useContext(AuthContext);
	const isAuthenticated = authContext?.isAuthenticated ?? false;
	const selectedUuid = useOrganizationStore((s) => s.selectedOrganizationUuid);
	const { data: userOrgs } = useUserOrganizations(isAuthenticated);

	if (!selectedUuid || !userOrgs) return null;

	const membership = userOrgs.find((o) => o.organization.uuid === selectedUuid);
	if (!membership) return null;

	return {
		organization_uuid: membership.organization.uuid,
		organization_name: membership.organization.name,
		organization_slug: membership.organization.slug,
		user_role: membership.role,
		is_default: membership.is_default,
	};
};
